/**
 * Video Testimonials Data
 * Customer video reviews
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const videoTestimonials = [
  {
    id: "1",
    src: `${assetsUrl}img/drops-video-reviews-1.jpg`,
    poster: `${assetsUrl}img/poster-1.webp`,
    headline:
      "Two weeks in and my stomach is noticeably flatter after meals. I don't get that heavy, stretched feeling anymore.",
    name: "Donna K.",
    isImage: true,
  },
  {
    id: "2",
    src: `${assetsUrl}img/drops-video-reviews-2.jpg`,
    poster: `${assetsUrl}img/poster-2.webp`,
    headline:
      "Down 5 lbs in a month without changing much. My clothes fit better and that's enough for me.",
    name: "Carol A.",
    isImage: true,
  },
  {
    id: "3",
    src: `${assetsUrl}img/drops-video-reviews-3.jpg`,
    poster: `${assetsUrl}img/poster-3.webp`,
    headline:
      "My skin is so much better. Less dullness and fewer breakouts along my jaw.",
    name: "Teresa H.",
    isImage: true,
  },
  {
    id: "4",
    src: `${assetsUrl}img/drops-video-reviews-4.jpg`,
    poster: `${assetsUrl}img/poster-4.webp`,
    headline:
      "The late night kitchen raids have basically stopped. That alone is worth it.",
    name: "Brenda P.",
    isImage: true,
  },
  {
    id: "5",
    src: `${assetsUrl}img/drops-video-reviews-5.jpg`,
    poster: `${assetsUrl}img/poster-5.webp`,
    headline:
      "I don't hit that 2pm wall anymore. Having energy all day makes me feel like a completely different person.",
    name: "Pamela J.",
    isImage: true,
  },
  {
    id: "6",
    src: `${assetsUrl}img/drops-video-reviews-6.jpg`,
    poster: `${assetsUrl}img/poster-1.webp`,
    headline:
      "My face looked swollen every morning for years. But now it’s less puffy!!!",
    name: "Debra N.",
    isImage: true,
  },
  {
    id: "7",
    src: `${assetsUrl}img/drops-video-reviews-7.jpg`,
    poster: `${assetsUrl}img/poster-2.webp`,
    headline: "Great detox that doesn't destroy your stomach",
    name: "Nancy F.",
    isImage: true,
  },
  {
    id: "8",
    src: `${assetsUrl}img/drops-video-reviews-8.jpg`,
    poster: `${assetsUrl}img/poster-2.webp`,
    headline:
      "Tastes fine, easy routine, and I can actually see the difference on my scale!",
    name: "Judy C.",
    isImage: true,
  },
];

export default videoTestimonials;
